import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ClientPartnerConfig, PartnerParams } from '@avalara/types/handshake';
import type { PartnerState } from '@avalara/types/reducer-states';

const initialState: PartnerState = {
  partnerConfig: null,
  partnerKey: null,
  partnerName: null,
  partnerParams: null,
};

const store = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setPartnerConfig: (state, action: PayloadAction<Partial<ClientPartnerConfig>>) => {
      state.partnerConfig = {
        ...state.partnerConfig,
        ...action.payload,
      };
    },
    setPartnerKey: (state, action: PayloadAction<string>) => {
      state.partnerKey = action.payload;
    },
    setPartnerName: (state, action: PayloadAction<string>) => {
      state.partnerName = action.payload;
    },
    setPartnerParams: (state, action: PayloadAction<Partial<PartnerParams>>) => {
      state.partnerParams = {
        ...state.partnerParams,
        ...action.payload,
      };
    },
  },
});

export const { setPartnerConfig, setPartnerKey, setPartnerName, setPartnerParams } = store.actions;

export default store;
